import styles from './WindowControls.module.css';

interface WindowControlsProps {
  onClose: (e: React.MouseEvent) => void;
  onMinimize: (e: React.MouseEvent) => void;
  onMaximize: (e: React.MouseEvent) => void;
}

export function WindowControls({ onClose, onMinimize, onMaximize }: WindowControlsProps) {
  return (
    <div className={styles.controls}>
      <button
        className={styles.dot}
        data-color="red"
        onClick={onClose}
        aria-label="Close"
      />
      <button
        className={styles.dot}
        data-color="yellow"
        onClick={onMinimize}
        aria-label="Minimize"
      />
      <button
        className={styles.dot}
        data-color="green"
        onClick={onMaximize}
        aria-label="Maximize"
      />
    </div>
  );
}
